import { SITE } from './site';

export const CONTACT_HERO = {
  tag: 'Get in touch',
  title: "Let's talk",
  subtitle:
    'Questions about partnerships, the platform, or early access? Email us, schedule a call, or send a message below.',
  chips: [
    { label: SITE.supportEmail, href: `mailto:${SITE.supportEmail}` },
    { label: 'Schedule a call', href: SITE.calendlyUrl },
    { label: SITE.location },
  ],
} as const;

export const CONTACT_FORM_POINTS = [
  'Share whether you are an investor, entrepreneur, or explorer',
  'Prefer a conversation? Book a 30-minute call on Calendly',
  'We respond to emails within 1-2 business days',
] as const;

export const CONTACT_CHANNELS = [
  {
    id: 'email',
    title: 'Email',
    eyebrow: 'Reach us directly anytime',
    value: SITE.supportEmail,
    accent: '#1e380f',
    action: {
      label: 'Send an email',
      sublabel: 'Direct line',
      href: `mailto:${SITE.supportEmail}`,
      icon: 'email' as const,
    },
  },
  {
    id: 'calendly',
    title: 'Schedule a call',
    eyebrow: 'Book a 30-minute session',
    value: 'Pick a time that works for you',
    accent: '#2d5016',
    action: {
      label: 'Schedule a call',
      sublabel: '30 minutes on Calendly',
      href: SITE.calendlyUrl,
      icon: 'calendar' as const,
    },
  },
  {
    id: 'location',
    title: 'Location',
    eyebrow: 'Where we are based',
    value: SITE.location,
    accent: '#3d7c1f',
    action: {
      label: 'View on map',
      sublabel: 'Headquarters',
      href: 'https://maps.google.com/?q=Nairobi,Kenya',
      icon: 'external' as const,
    },
  },
] as const;

export const CONTACT_TOPICS = [
  {
    title: 'Early access',
    description: 'Join the waitlist and be first when Hello Gwiji launches across every platform.',
  },
  {
    title: 'Partnerships',
    description: 'Questions about capital partnerships, transparent terms, or how matching works.',
  },
  {
    title: 'Platform support',
    description: 'Help with your account, wallet activity, or getting started on the application.',
  },
  {
    title: 'Press & media',
    description: 'Brand assets, interviews, and announcements about Hello Gwiji.',
  },
] as const;

export type ContactChannel = (typeof CONTACT_CHANNELS)[number];
